import { render, staticRenderFns } from "./base-carousel.vue?vue&type=template&id=03c4dcc4&"
import script from "./base-carousel.vue?vue&type=script&lang=js&"
export * from "./base-carousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johndwells/Git/hys/penge-polls/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03c4dcc4')) {
      api.createRecord('03c4dcc4', component.options)
    } else {
      api.reload('03c4dcc4', component.options)
    }
    module.hot.accept("./base-carousel.vue?vue&type=template&id=03c4dcc4&", function () {
      api.rerender('03c4dcc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/vue/base/base-carousel.vue"
export default component.exports